import { render, staticRenderFns } from "./SidebarCartItem.vue?vue&type=template&id=721f8ef0&scoped=true&"
import script from "./SidebarCartItem.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCartItem.vue?vue&type=style&index=0&id=721f8ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f8ef0",
  null
  
)

export default component.exports